import React from 'react'
import Swal from 'sweetalert2'
import { Button } from 'primereact/button'
import { deleteData } from '../../../actions/servicesHttp'
import { modifyProxy } from '../toolsFunctions'
import PropTypes from 'prop-types'
import '../../../css/generals/sweetAlert.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function ActionDelete ({ table, id, reload }) {
  const { t } = useTranslation('deleteAction')
  const navigate = useNavigate()

  async function deleted () {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons
      .fire({
        title: t('title'),
        text: table === 'groups' ? t('paragraph') : '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('button1'),
        cancelButtonText: t('button2'),
        reverseButtons: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          let trash
          if (
            table === 'keyWords' ||
            table === 'blackList' ||
            table === 'whiteList'
          ) {
            trash = await deleteData(
              `safeweb/${table}`,
              id,
              navigate
            )
          } else {
            trash = await deleteData(table, id, navigate)
          }

          if (trash.data.result) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: t('message1'),
              showConfirmButton: false,
              timer: 1500
            })
            reload(true)
            if (table === 'keyWords' || table === 'blackList' || table === 'whiteList') modifyProxy(table, navigate)
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: t('message2'),
              showConfirmButton: false,
              timer: 1500
            })
          }
        }
      })
  }

  return (<Button icon="pi pi-trash" className="p-button-rounded p-button-danger btn-white" aria-label="Cancel" onClick={() => deleted()} />)
}

ActionDelete.propTypes = {
  table: PropTypes.string,
  id: PropTypes.number,
  reload: PropTypes.func
}
